<rlst-modal *ngIf="exportInfo$ | async as exportInfo" header="Custom Export" (closeModal)="close()" class="modal-content">
  <div class="selection-header d-flex align-items-center text-black">
    <span>Please select recent saved export or create a new one:</span>
    <rlst-action-dropdown defaultActionName="Create New Export"
                          [itemList]="exportFormsList"
                          (defaultAction)="createNewExport()"
                          (itemAction)="openExport($event)"
                          [currentItem]="currentExport || {label: 'New Export'}"
                          class="dropdown">
    </rlst-action-dropdown>
  </div>
  <div class="sub-header d-flex justify-content-between">
    <fieldset class="d-flex align-items-center edit-name">
      <button type="button" *ngIf="!isAdmin" class="btn-custom btn-small mr-1" (click)="editNameField.focus()">
        <i class="far fa-pencil" aria-hidden="true"></i>
        <span class="sr-only">Edit</span>
      </button>
      <div class="locked d-flex" *ngIf="isAdmin">
        <i class="far fa-lock" aria-hidden="true"></i>
        <span class="sr-only">Owned by</span> Admin
      </div>
      <input #editNameField
             [formControl]="editNameControl"
             type="text"
             class="form-control"
             maxlength="30"
             [ngClass]="{'error': editNameControl.hasError('required') && editNameControl.touched}"
             placeholder="Type Export Name*">
    </fieldset>

    <div class="d-flex align-items-center" *ngIf="currentExport">
      <p class="mb-0"><span class="date-label">Date modified:</span> {{currentExport.modifiedDate | date: 'MM/dd/yyyy'}}</p>
      <ng-container *ngIf="!isAdmin">
        <span class="separator">|</span>
        <button type="button" class="btn-custom btn-small" (click)="deleteExport()">
          <i class="fa fa-trash-o" aria-hidden="true"></i> Delete Export
        </button>
      </ng-container>
    </div>
  </div>
  <div class="content" *ngIf="maxNumber$ | async as maxNumber">
    <div class="d-flex flex-column" *ngIf="!isAdmin">
      <rlst-categories-list [categories]="categories"
                            (categorySelection)="setCategory($event)"
                            [selectedCategory]="selectedCategory"
                            isMobileNextStep="false"
                            headerTitle="Categories"
                            aggregateCategoryTitle="All Categories"
                            class="h-100 categories">
      </rlst-categories-list>
    </div>
    <div class="d-flex flex-column w-100">
      <div class="half-height" *ngIf="isAdmin">
        <p class="admin-message text-black">This export was configured by Admin. It cannot be edited or deleted.</p>
      </div>
      <rlst-attributes-selection isMobileNextStep="false"
                                 *ngIf="!isAdmin"
                                 [attributes]="attributesToDisplay"
                                 [maxNumber]="maxNumber"
                                 [selectedNumber]="selectedItems.length"
                                 class="min-height-200 half-height w-100"
                                 headerTitle="Attributes"
                                 (attributeIsSelected)="selectAttribute($event, true)">
      </rlst-attributes-selection>
      <rlst-export-options (range)="setRange($event)"
                           (exportRangeValid)="setExportRangeValidity($event)"
                           [recordsNumber]="checkedPropertiesCount"
                           class="d-flex py-5 flex-column justify-content-center export-options">
      </rlst-export-options>
    </div>
    <div class="d-flex flex-column">
      <rlst-selected-properties (closeModal)="close()"
                                 headerTitle="Selected Attributes"
                                 nextStepButtonLabel="Select Attributes"
                                 class="selected-options half-height min-height-200 d-flex"
                                 [selectedItems]="selectedItems"
                                 [isDisabled]="isAdmin"
                                 (toggleMobileNextStep)="toggleMobileNextStep()"
                                 (clearSelection)="clearSelection()"
                                 (registerChanges)="registerChange()"
                                 (itemRemoved)="removeAttribute($event)">
        <ng-template #selectedProperty let-item>
          <div>
            <p class="current-item m-0">
              {{item.fieldLabel}}
            </p>
          </div>
        </ng-template>
      </rlst-selected-properties>
      <rlst-export-limit-status
        [exportInfo]="exportInfo"
        [recordsNumber]="checkedPropertiesCount"
        class="export-window flex-shrink-0">
      </rlst-export-limit-status>
    </div>
  </div>
  <div mat-dialog-actions class="actions-panel">
    <div class="flex-spacer">
      <span class="error" *ngIf="isLimitExceeded()">
        Limit has been exceeded. No records available for download.
      </span>
    </div>
    <button type="button" (click)="close()" class="btn-custom btn-custom-outline-blue-dark cancel-button">Cancel</button>
    <button type="button"
            (click)="saveExport()"
            [disabled]="!selectedItems.length || !editNameControl.value || !selectionHasChanges"
            class="btn-custom btn-custom-blue-dark justify-content-center">Save</button>
    <button type="button"
            class="btn-custom btn-custom-blue-dark"
            (click)="runExport()"
            [disabled]="!isExportRangeValid || !selectedItems.length || isLimitExceeded()">
      Export
    </button>
  </div>
</rlst-modal>
